<div class="modal-header">
    <h5 class="modal-title">Share to Contact</h5>
    <span class="fa fa-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></span>
</div>
<div class="modal-body">
    
    <ng-select placeholder="Select contact(s)" [(ngModel)]="selectedContact" [multiple]="true">
        <ng-option *ngFor="let contact of contacts" [value]="contact.id">{{contact.name}}</ng-option>
     </ng-select>
     
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="sendRequest()" [disabled]="selectedContact.length == 0">Share</button>
    <button type="button" class="btn btn-default" (click)="activeModal.close('Close click')">Cancel</button>
</div>